import { useContext } from "react";
import CheckUpContext from "../../context/check-up";
import CmsContent from "../cms-content";
import AppError from "../app-error";

const CheckUpDetail = ({ data }) => {
  const { labels, infoError } = useContext(CheckUpContext);

  return infoError ? (
    <AppError labels={labels} />
  ) : (
    <div className="wrapper wrapper-small wrapper--coldpage">
      <CmsContent data={data} />
      {/* <div className="form__buttons form__buttons--center">
        <button
          className="button primary form__submit"
          onClick={() => {
            setCurrentRequest("new");
            setNavigation("detail");
          }}
        >
          {labels?.WELFARE_CHECKUP_BOOKING_CTA || "Prenota check-up"}
        </button>
      </div> */}
    </div>
  );
};

export default CheckUpDetail;
